import React from "react";
import { Route, Routes } from "react-router-dom";
import PlatformConsoleHome from "./PlatformConsoleHome";
import WorkspaceDetailPage from "./WorkspaceDetailPage";

/**
 Console da plataforma (master xprobase). Rotas relativas ao prefixo /platform/xprobase/*
 */
const PlatformXprobaseConsole = () => {
  return (
    <Routes>
      <Route index element={<PlatformConsoleHome />} />
      <Route path="workspaces/:dominioId" element={<WorkspaceDetailPage />} />
    </Routes>
  );
};

export default PlatformXprobaseConsole;
